import React, { ReactNode } from 'react'
import classnames from 'classnames/bind'
import Link from 'next/link'

// Components
import Icon from '@/assets/icons'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'

// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)

interface ILink {
  url: string
  children: ReactNode
}

const links: ILink[] = [
  {
    url: EXTERNAL_LINK.APP_STORE,
    children: <Icon.Download_AppStore />,
  },
  {
    url: EXTERNAL_LINK.GOOGLE_PLAY,
    children: <Icon.Download_GooglePlay />,
  },
]

const DownloadApps = () => {
  return (
    <div className={cx('download-apps')}>
      {links.map((link) => (
        <Link href={link.url} key={link.url} target='_blank'>
          {link.children}
        </Link>
      ))}
    </div>
  )
}

export default DownloadApps
